import { getPricingAnalyticsProperties, PricingEntryPoint } from '@/shared/lib/pricingAttribution';
import { GTMEvents } from '@/shared/thirdParty/gtm';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PaymentInterval, Plan, Price } from '@/shared/types/Billing';

type TrackSubscriptionCheckoutCreatedParams = {
  /** Present for Stripe-hosted checkout; the in-app checkout has no session. */
  checkoutSessionId?: null | string;
  plan: Pick<Plan, 'category' | 'prices'>;
  priceId: Price['id'];
  pricingEntryPoint: PricingEntryPoint;
  /** The billing period the user chose; the price's own period wins when the plan has the price. */
  selectedInterval?: PaymentInterval;
};

/** A checkout for the chosen plan was created (Stripe returned it), right before the user is sent to pay. */
export const trackSubscriptionCheckoutCreated = ({
  checkoutSessionId,
  plan,
  priceId,
  pricingEntryPoint,
  selectedInterval,
}: TrackSubscriptionCheckoutCreatedParams) => {
  const interval = plan.prices.find((price) => price.id === priceId)?.recurring?.interval ?? selectedInterval;

  MixpanelEvents.subscriptionCheckoutCreated({
    ...getPricingAnalyticsProperties(pricingEntryPoint),
    interval: interval === PaymentInterval.Year ? 'annual' : 'monthly',
    plan: plan.category,
    price_id: priceId,
  });

  if (checkoutSessionId) GTMEvents.checkoutSessionCreated(checkoutSessionId);
};
